import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InternalUnregisteredConversationNotes from 'components/molecules/smsDashboard/internalUnregisteredConversationNotes';

import s from './styles.module.scss';

const SidebarUnregistered = () => {
  const { t } = useTranslation();

  const [notesCount, setNotesCount] = useState(0);

  return (
    <div className={s.sidebar}>
      <div className={s.tabs}>
        <p className={s.title}>
          {t('smsDashboard.notes')} ({notesCount})
        </p>
      </div>

      <InternalUnregisteredConversationNotes setNotesCount={setNotesCount} />
    </div>
  );
};

export default SidebarUnregistered;
